import { render, staticRenderFns } from "./SelectedFiltersPanel.vue?vue&type=template&id=1cbdbc50&scoped=true"
import script from "./SelectedFiltersPanel.vue?vue&type=script&lang=js"
export * from "./SelectedFiltersPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbdbc50",
  null
  
)

export default component.exports